/* MessageLoader.tsx
   Version: 1.0.0
   Date: 2020-12-03
*/

// eslint-disable-next-line
import React from 'react';
import Modal from './Modal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface MessageLoaderProps { }

const MessageLoader: React.FC<MessageLoaderProps> = (): JSX.Element => {
    
    return(
        <Modal>
            <div className="modal">
                <img className='modal-loader' src={`${process.env.PUBLIC_URL}/gif/sym-loader.gif`} alt='Just a second...' />
            </div>
        </Modal>
    );

}

export default MessageLoader;
